
import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export default function FloatingContact() {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();

    const contactOptions = [
        {
            icon: 'ri-whatsapp-line',
            href: 'https://wa.me/905300959741',
            color: 'from-green-500 to-emerald-500',
            shadow: 'hover:shadow-green-500/50',
            label: t('whatsapp', { ns: 'contact' }),
            delay: 0
        },
        {
            icon: 'ri-instagram-line',
            href: 'https://instagram.com/dynamixsteelfiber',
            color: 'from-pink-500 via-purple-500 to-orange-400',
            shadow: 'hover:shadow-pink-500/50',
            label: t('instagram', { ns: 'contact' }),
            delay: 0.05
        },
        {
            icon: 'ri-phone-line',
            href: 'tel:+905300959741',
            color: 'from-teal-500 to-cyan-500',
            shadow: 'hover:shadow-teal-500/50',
            label: t('phone', { ns: 'contact' }),
            delay: 0.1
        },
        {
            icon: 'ri-mail-line',
            href: 'mailto:info@dynamixsteelfiber.com',
            color: 'from-blue-500 to-indigo-500',
            shadow: 'hover:shadow-blue-500/50',
            label: t('email', { ns: 'contact' }),
            delay: 0.15
        }
    ];

    return (
        <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-4">
            <AnimatePresence>
                {isOpen && (
                    <div className="flex flex-col gap-3 mb-2 items-end">
                        {contactOptions.map((option) => (
                            <motion.a
                                key={option.label}
                                href={option.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                initial={{ opacity: 0, y: 20, scale: 0.8 }}
                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                exit={{ opacity: 0, y: 20, scale: 0.8 }}
                                transition={{ duration: 0.3, delay: option.delay }}
                                className="flex items-center gap-3 pl-4 pr-1 py-1 rounded-full group"
                            >
                                <span className="bg-white text-gray-800 text-xs font-bold px-2 py-1 rounded shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
                                    {option.label}
                                </span>
                                <div
                                    className={`w-12 h-12 flex items-center justify-center rounded-full text-white shadow-lg bg-gradient-to-br ${option.color} ${option.shadow} transition-transform duration-300 hover:scale-110`}
                                >
                                    <i className={`${option.icon} text-xl`}></i>
                                </div>
                            </motion.a>
                        ))}
                    </div>
                )}
            </AnimatePresence>

            <motion.button
                onClick={() => setIsOpen(!isOpen)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className={`w-14 h-14 flex items-center justify-center rounded-full shadow-xl text-white transition-colors duration-300 ${isOpen ? 'bg-gray-800' : 'bg-cyan-500 hover:bg-cyan-400'
                    }`}
            >
                <i className={`${isOpen ? 'ri-close-line' : 'ri-chat-smile-3-line'} text-2xl`}></i>
            </motion.button>
        </div>
    );
}
